import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

// Add current domain to the config for better URL handling
const currentDomain = window.location.hostname;
const port = window.location.port ? `:${window.location.port}` : '';
const origin = `${window.location.protocol}//${currentDomain}${port}`;

console.log(`Current domain: ${origin}`);

// Your web app's Firebase configuration - hardcoded to avoid env issues
const firebaseConfig = {
  apiKey: "AIzaSyA5whq-_6pEaK9sVpzHSLAJ79iMyrJo5Es",
  authDomain: "arteico-launcher.firebaseapp.com",
  projectId: "arteico-launcher",
  storageBucket: "arteico-launcher.firebasestorage.app",
  messagingSenderId: "55531410032",
  appId: "1:55531410032:web:51cc874c68f4d9c3d9404",
  measurementId: "G-K503Z8972"
};

// Initialize Firebase
console.log('Initializing Firebase...');
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const firestore = getFirestore(app);

// Set persistence to local (browser) storage instead of session
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("Firebase persistence set to LOCAL");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error);
  });

// Print auth info for debugging
console.log('Firebase app initialized');
console.log('Auth domain:', firebaseConfig.authDomain);
console.log('Current origin:', origin);

// Use the device language
auth.useDeviceLanguage();

// Expose these globally for easier debugging if needed
(window as any).firebaseAuth = auth;
(window as any).firebaseApp = app;
(window as any).firebaseStorage = storage;
(window as any).firebaseFirestore = firestore;

export { app, auth, storage, firestore }; 